<template>
  <section
    :id="module.id"
    class="chapter-wrapper"
    :style="[chapterWrapperElStyles]"
  >
    <GlobalUIMedia
      v-if="module.config.general.showMedia"
      :media="module.config.general.media"
      :lazy="lazy"
    />
    <component
      :is="module.config.general.template.component"
      @click="$emit('emittedClick', module.config)"
      :style="modulePadding"
    >
      <template #image>
        <img
          :src="appendCdnParams(module.config.media.media.url)"
          :srcset="
            setImageSrcSet(
              module.config.media.media.url,
              mobileWidth,
              tabletWidth,
              laptopWidth,
              desktopWidth,
            )
          "
          :sizes="
            setImageSizes(mobileWidth, tabletWidth, laptopWidth, desktopWidth)
          "
          :alt="module.config.media.mediaAltText"
          :style="mediaElStyles"
          :loading="lazy ? 'lazy' : 'eager'"
        />
      </template>

      <template #header>
        <h3
          v-if="module.config.general.showHeader"
          :style="headerElStyles"
          v-html="module.config.header.text"
        ></h3>
      </template>

      <template #text>
        <div
          class="text"
          :style="textElStyles"
          v-html="module.config.text.text"
        ></div>
      </template>

      <template #button>
        <GlobalUICtaButton
          v-if="module.config.general.showCta"
          :ctaButton="module.config.ctaButton"
          @click="$emit('emittedClick')"
        />
      </template>
    </component>
  </section>
</template>

<script>
import chapterModule from "./chapterDefaultModuleProp.js";
import ChapterRight from "./Templates/ChapterRight.vue";
import ChapterLeft from "./Templates/ChapterLeft.vue";
import { chapterComputed } from "./mixins/chapter.js";

import { globalComputed, globalMethods } from "../GlobalUI/mixins/global.js";
import GlobalUICtaButton from "../GlobalUI/GlobalUICtaButton.vue";
import GlobalUIMedia from "../GlobalUI/GlobalUIMedia.vue";

export default {
  components: {
    GlobalUIMedia,
    GlobalUICtaButton,
    ChapterRight,
    ChapterLeft,
  },
  name: "Chapter",
  mixins: [chapterComputed, globalComputed, globalMethods],
  props: {
    module: {
      type: Object,
      default() {
        return chapterModule;
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mobileWidth: 343,
      tabletWidth: 369,
      laptopWidth: 544,
      desktopWidth: 672,
    };
  },
  computed: {
    chapterWrapperElStyles() {
      const { backgroundColor } = this.module.config.general;

      return {
        backgroundColor: backgroundColor.value,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./scss/shared";

.chapter-wrapper {
  container-type: inline-size;
  contain: layout;
}
</style>
